module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_0@3x.24cbe748.png";